import './App.css';
import "./common/services/i18n";

import DateFnsUtils from "@date-io/date-fns";
import { ThemeProvider } from "@material-ui/core";
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { RootStore } from 'common/store';
import countries from "i18n-iso-countries";
import de from "i18n-iso-countries/langs/de.json";
import en from "i18n-iso-countries/langs/en.json";
import React from 'react';
import { Provider } from 'react-redux';

import { AppRouter } from "./AppRouter";
import { theme } from "./theme";

countries.registerLocale(en);
countries.registerLocale(de);

function App() {
  return (
    <Provider store={RootStore}>
      <ThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <div className="App">
            <AppRouter />
          </div>
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
